export type RoleType = "superAdministrator" | "administrator" | "agent";

export enum RoleEnum {
  SUPERADMINISTRATOR = "superAdministrator",
  ADMINISTRATOR = "administrator",
  AGENT = "agent",
}
